webpackJsonp([35783957827783],{

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _config = __webpack_require__(14);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _reactResponsiveCarousel = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Home = function Home() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'span',
	      {
	        style: {
	          fontFamily: "'Euphoria Script', cursive",
	          fontSize: '80px',
	          fontWeight: 'bold',
	          color: _config2.default.site.textColor,
	          lineHeight: '1em'
	        } },
	      _config2.default.personalInfo.bride + ' & ' + _config2.default.personalInfo.groom
	    ),
	    _react2.default.createElement(
	      _reactResponsiveCarousel.Carousel,
	      { showThumbs: false },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('img', { src: _config2.default.img.couplePic, alt: _config2.default.personalInfo.couple })
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('img', { src: _config2.default.img.couple2, alt: _config2.default.personalInfo.couple, style: { maxHeight: 600, width: 'auto' } })
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('img', { src: _config2.default.img.couple3, alt: _config2.default.personalInfo.couple, style: { maxHeight: 600, width: 'auto' } })
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('img', { src: _config2.default.img.couple4, alt: _config2.default.personalInfo.couple, style: { maxHeight: 600, width: 'auto' } })
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('img', { src: _config2.default.img.couple5, alt: _config2.default.personalInfo.couple, style: { maxHeight: 600, width: 'auto' } })
	      )
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'p',
	      {
	        style: {
	          fontWeight: 'bold',
	          fontFamily: "'Dancing Script', cursive",
	          fontSize: '25px',
	          color: _config2.default.site.textColor
	        } },
	      _config2.default.wedding.prettyDate
	    ),
	    _react2.default.createElement(
	      'p',
	      {
	        style: {
	          fontWeight: 'bold',
	          fontSize: '25px',
	          fontFamily: "'Dancing Script', cursive",
	          color: _config2.default.site.textColor
	        } },
	      _config2.default.wedding.location
	    )
	  );
	};
	
	exports.default = Home;
	module.exports = exports['default'];

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Home = __webpack_require__(70);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(_Home2.default, null);
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-06e7bbf8515b25126435.js